<template lang="pug">
    .scene.scene_general
        .layer(v-parallax="0.15")
            .scene--group
                h3.scene--subtitle(v-for="item in displayText", v-bind:key="item.index") {{item}}
</template>
<script>
let lineItem = new TimelineLite()
export default {
    data() {
        return {
            lineIndex: 0,
            done: false,
            paused: false
        }
    },
    props: {
        content: {
            type: Array,
            required: true,
            default: [ 'Lorem ipsum', 'Lorem ipsum' ]
        }
    },
    mounted() {
        console.log('sceneText mounted')
        this.showLines()
    },
    methods: {
        showLines() {
            console.log('showLines started')
            let lineItem = new TimelineLite()
            lineItem
                .fromTo('.scene--group', 1, { opacity: 0 }, { opacity: 1 })
                .staggerFromTo('.scene--subtitle', 1, {opacity: 0, delay: 0.5 }, { opacity: 1 }, 1.1)
                .to('.scene--group', 2, { opacity: 0, delay: 1, onComplete: () => {
                    this.allComplete()
                }})
        },
        increaseIndex() {
            this.lineIndex ++
        },
        allComplete() {
            if (this.lineIndex === this.content.length - 1) {
                this.$emit('sceneTextDone')
                this.done = true
                lineItem.invalidate()
                lineItem.kill()
            } else {
                this.increaseIndex()
                this.showLines()
            }
        }
    },
    beforeDestroy() {
        console.log('sceneText before destroy')
        lineItem.kill()
    },
    computed: {
        displayText() {
            return this.content[this.lineIndex]
        }
    }
}
</script>
<style lang="scss" scoped>
    .scene--group {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/sceneText.vue